import { useEffect, useRef, useState } from "react";

import { Input } from "src/components/UI/Forms/Inputs";
import Modal from "src/components/UI/Modal";
import ModalHeader from "src/components/UI/Modal/modalHeader";
import { TrailerNo } from "src/utils/validations/formValidations";
import { useForm } from "react-hook-form";
import {
  useAddTrailerMutation,
  useDeleteTrailerMutation,
  useGetTrailersListQuery,
  useSearchVehicleQuery,
  useUpdateTrailerMutation,
} from "src/services/transporterVehicles/transporterVehicles";
import { getUser } from "src/utils/user/user";
import CustomSnackbar from "src/components/UI/Alerts/customSnackbar";
import { TransporterTrailerList } from "src/components/Transporter/transporterTrailerList";
import TrailerCard from "src/components/Transporter/trailerCard";
import { useTranslation } from "react-i18next";

export interface ITrailerProps {}

export function TransporterTrailer(props: ITrailerProps) {
  const user = getUser();
  const { data: TrailerData, refetch: refetchTrailerData } =
    useGetTrailersListQuery(user.company._id);
  const [searchString, setSearchString] = useState(null);
  const { data: VehicleFirstFiltered } = useSearchVehicleQuery(
    { search: searchString },
    {
      skip: !searchString,
    }
  );
  const [showTrailer, setShowTrailer] = useState(false);
  const [trailerFullData, setTrailerFullData] = useState([]);
  const [selectedTrailer, setSelectedTrailer] = useState<any>({});
  const [showConfirm, setShowConfirm] = useState(false);
  const [showAddTrailer, setShowAddTrailer] = useState(false);
  const [showEditTrailer, setShowEditTrailer] = useState(false);
  const [addTrailer] = useAddTrailerMutation();
  const [updateTrailer] = useUpdateTrailerMutation();
  const [deleteTrailer] = useDeleteTrailerMutation();
  const [isDateError] = useState(false);
  const datePickerRef = useRef<HTMLDivElement>(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<
    "success" | "info" | "warning" | "error"
  >("success");

  if (user) {
    let companyDetails = user;
    var companyId = companyDetails?.company?._id;
  }
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const OnChangeSearch = (searchString: any) => {
    setSearchString(searchString);
    // setFilteredOrders(filterOrders(Orders, searchString));
  };
  useEffect(() => {
    if (searchString === null) {
      setTrailerFullData(TrailerData);
    }
    setTrailerFullData(TrailerData);
  }, [TrailerData, searchString]);

  useEffect(() => {
    if (searchString != null) {
      setTrailerFullData(TrailerData);
      setTrailerFullData(VehicleFirstFiltered);
    }
  }, [VehicleFirstFiltered, searchString, TrailerData]);

  const onAddTrailer = (data: any) => {
    const _payload = {
      number: data.trailerNo,
      transportCompany: companyId,
    };
    addTrailer(_payload)
      .then((response: any) => {
        if (response && response.data) {
          setSnackbarMessage("Trailer added successfully");
          setSnackbarSeverity("success");
          setOpenSnackbar(true);
          setShowAddTrailer(false);
          refetchTrailerData();
          reset({
            trailerNo: "",
          });
        } else if (response.error.data.message) {
          setSnackbarMessage(response.error.data.message);
          setSnackbarSeverity("error");
          setOpenSnackbar(true);
        }
      })
      .catch((error) => {
        setSnackbarMessage("Something went wrong.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      });
  };

  useEffect(() => {
    reset({
      trailerNo: selectedTrailer?.number || "",
    });
  }, [selectedTrailer, reset]);

  const onUpdateTrailer = (data: any) => {
    const _payload = {
      number: data.trailerNo,
      transportCompany: companyId,
    };
    updateTrailer({ data: _payload, id: selectedTrailer._id })
      .then((response: any) => {
        if (response) {
          setSnackbarMessage("Trailer updated successfully");
          setSnackbarSeverity("success");
          setOpenSnackbar(true);
          setShowEditTrailer(false);
          setShowTrailer(false);
          refetchTrailerData();
          reset({
            trailerNo: "",
          });
        } else if (response.error.data.message) {
          setSnackbarMessage(response.error.data.message);
          setSnackbarSeverity("error");
          setOpenSnackbar(true);
        }
      })
      .catch((error) => {
        setSnackbarMessage("Something went wrong.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      });
  };

  const onEditTrailer = (trailer: any) => {
    setShowTrailer(false);
    setShowEditTrailer(true);
  };

  const onDeleteTrailer = () => {
    deleteTrailer({ id: selectedTrailer._id })
      .then((response: any) => {
        if (response) {
          setSnackbarMessage("Trailer deleted successfully");
          setSnackbarSeverity("error");
          setOpenSnackbar(true);
          setShowAddTrailer(false);
          setShowConfirm(false);
          setShowEditTrailer(false);
          refetchTrailerData();
        } else if (response.error.data.message) {
          setSnackbarMessage(response.error.data.message);
          setSnackbarSeverity("error");
          setOpenSnackbar(true);
        }
      })
      .catch((error) => {
        setSnackbarMessage("Something went wrong.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      });
  };

  useEffect(() => {
    if (isDateError && datePickerRef.current) {
      datePickerRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [isDateError]);

  const { t } = useTranslation();

  return (
    <>
      <div className="w-full h-screen px-6 overflow-y-auto pt-4" style={{ backgroundColor: "var(--bg-base)", color: "var(--text-main)" }}>
        <CustomSnackbar
          open={openSnackbar}
          handleClose={() => setOpenSnackbar(false)}
          message={snackbarMessage}
          severity={snackbarSeverity}
        />
        <div className="sticky top-0 z-10 py-4 pb-4" style={{ backgroundColor: "var(--bg-base)" }}>
          <div className="grid grid-cols-6 gap-4">
            <h3 className="col-span-3 mb-2 text-2xl">
              {t("trailers_page.title")}
            </h3>
            <div className="grid grid-cols-3 col-span-3 xl:grid-cols-4 gap-7">
              <div className="col-span-2 xl:col-span-3">
                <Input
                  type="text"
                  placeholder={t("trailers_page.search_trailer_textbox")}
                  inputClassName="shadow-sm border border-[var(--border-light)] rounded-lg placeholder:text-[var(--text-muted)] text-[var(--text-main)]"
                  onChange={(e: any) => OnChangeSearch(e.target.value)}
                  iconUrl="/assets/icons/search.svg"
                ></Input>
              </div>
              <div className="ltr:text-right rlt:text-left">
                <button
                  className="p-3 mb-8 text-white rounded-lg bg-danger"
                  onClick={() => setShowAddTrailer(true)}
                >
                  {t("trailers_page.vehicle_trailers_btn")}
                </button>
              </div>
            </div>
          </div>
        </div>
        <section></section>
        <section>
          <div className="rounded-lg bg-white/[0.04]">
            {trailerFullData && trailerFullData?.length !== 0 ? (
              trailerFullData?.map((trailer: any) => (
                <TransporterTrailerList
                  key={trailer?._id}
                  trailer={trailer}
                  OnAction={(trailer: any) => {
                    // fetchVehicle(trailer._id)
                    setSelectedTrailer(trailer);
                    setShowTrailer(true);
                  }}
                  onClose={() => {
                    // setShowVehicle(true);
                  }}
                />
              ))
            ) : (
              <div className="px-6">
                <div className="sticky top-0 z-10 flex flex-col items-center py-8 pb-4 mt-48">
                  <h3 className="col-span-2 mt-10 mb-2 text-2xl tracking-wide text-center">
                    No trailers available
                  </h3>
                  <div className="w-[100px] mt-2 h-1 bg-gradient-to-r from-transparent via-[var(--color-primary)] to-transparent"></div>
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
      {/* ==================================================ADD DRIVER=========================================== */}
      <Modal
        show={showAddTrailer}
        onClose={() => setShowAddTrailer(false)}
        align="right"
        className="w-1/3 shadow-card bg-[var(--bg-surface)] text-[var(--text-main)]"
      >
        <div className="h-screen">
          <div className="p-8 pb-0 ">
            <img
              onClick={() => setShowAddTrailer(false)}
              src="/assets/icons/cross.svg"
              alt="close"
              className="ltr:float-right rtl:float-left cursor-pointer"
            ></img>
            <h3 className="mb-10 text-2xl text-white">
              {t("trailers_page.vehicle_trailers_btn")}
            </h3>
            <form className="h-[80vh] overflow-y-scroll pe-5">
              <Input
                type="text"
                name="trailerNo"
                label={t("trailers_page.trailer_number")}
                placeholder="Enter trailer number"
                className="!mb-9"
                labelClassName="!text-blue/[0.7] !text-sm !mb-2"
                inputClassName="bg-white/[0.04] border-white/[0.3] text-white placeholder:opacity-30"
                register={register}
                validation={TrailerNo}
                error={errors.trailerNo}
                errorText="Enter trailer number"
              />
              <button
                className="w-full p-3 text-white rounded-lg bg-danger"
                onClick={handleSubmit((d) => onAddTrailer(d))}
              >
                {t("trailers_page.vehicle_trailers_btn")}
              </button>
            </form>
          </div>
        </div>
      </Modal>

      <Modal
        show={showEditTrailer}
        onClose={() => setShowEditTrailer(false)}
        align="right"
        className="w-1/3 shadow-card bg-[var(--bg-surface)] text-[var(--text-main)]"
      >
        <div className="h-screen">
          <div className="p-8 pb-0 ">
            <img
              onClick={() => setShowEditTrailer(false)}
              src="/assets/icons/cross.svg"
              alt="close"
              className="lrt:float-right rtl:float-left cursor-pointer"
            ></img>
            <h3 className="mb-10 text-2xl text-white">
              {t("trailers_page.edit_trailer")}
            </h3>
            <form className="h-[80vh] overflow-y-scroll pe-5">
              <Input
                type="text"
                name="trailerNo"
                label={t("trailers_page.trailer_number")}
                placeholder="Enter trailer number"
                className="!mb-9"
                labelClassName="!text-blue/[0.7] !text-sm !mb-2"
                inputClassName="bg-white/[0.04] border-white/[0.3] text-white placeholder:opacity-30"
                register={register}
                validation={TrailerNo}
                defaultValue={selectedTrailer.number || ""}
                error={errors.trailerNo}
                errorText="Enter trailer number"
              />
              <button
                className="w-full p-3 text-white rounded-lg bg-danger"
                onClick={handleSubmit((d) => onUpdateTrailer(d))}
              >
                Save
              </button>
            </form>
          </div>
        </div>
      </Modal>
      {/* ================================================================================================================== */}
      <Modal
        show={showTrailer}
        onClose={() => setShowTrailer(false)}
        align="right"
        className="w-[30%] shadow-card bg-[var(--bg-surface)] text-[var(--text-main)]"
      >
        <div className="h-screen">
          <div className=" h-[86vh] overflow-y-scroll">
            <ModalHeader
              title={t("trailers_page.trailer_details")}
              onClose={() => setShowTrailer(false)}
              className="px-8"
            />
            <div className="px-8 pb-10 text-white">
              {TrailerData && <TrailerCard trailer={selectedTrailer as any} />}
            </div>
            <div className="grid grid-cols-12 gap-4 p-6">
              <button
                className="w-full col-span-5 p-3 text-white border border-white rounded-lg"
                onClick={() => onEditTrailer(selectedTrailer)}
              >
                {t("trailers_page.edit_btn")}
              </button>
              <button
                className="w-full col-span-7 p-3 text-white rounded-lg bg-danger"
                onClick={() => setShowConfirm(true)}
              >
                {t("trailers_page.delete_btn")}
              </button>
            </div>
          </div>
          <div
            className={`absolute bottom-0 w-full px-8 pt-3 pb-8 shadow-md z-0`} style={{ backgroundColor: "var(--bg-surface)", borderTop: "1px solid var(--border-light)" }}
          ></div>
        </div>
      </Modal>

      <Modal
        show={showConfirm}
        onClose={() => setShowConfirm(false)}
        align="center"
        className="rounded-lg shadow-card mx-auto w-[25%] top-10 start-1/2 transform -translate-x-1/2 bg-[var(--bg-surface)] text-[var(--text-main)]"
      >
        <div className="p-6 text-center" style={{ color: "var(--text-main)" }}>
          <img
            src={`/assets/icons/orders/jobDetails/truck-big.svg`}
            alt="lock"
            className="mx-auto mb-3"
          />
          <h3 className="mb-2 text-lg font-semibold">Remove Trailer?</h3>
          <p className="text-white/[0.85] text-sm mb-6">
            You are about to permanently remove this trailer from the list. This
            action cannot be undone. Do you wish to proceed?
          </p>
          <div className="grid grid-cols-2 gap-4 mt-3 mb-3">
            <button
              className="p-3 text-white border border-white rounded-lg "
              onClick={() => setShowConfirm(false)}
            >
              Cancel
            </button>
            <button
              className="p-3 text-white rounded-lg bg-danger "
              onClick={() => {
                onDeleteTrailer();
              }}
            >
              Delete
            </button>
          </div>
          {/* <p className="text-white/[0.7] text-sm">{unlockMessage}</p> */}
        </div>
      </Modal>
    </>
  );
}
